<div class="arrowLeft">
    <!-- <div class="line1"></div> -->
    <!-- <div class="line2"></div> -->
    <!-- <div class="circle"></div> -->
     <img src="assets/img/icons/arrow-left.png" alt="">
     <img class="over" src="assets/img/icons/arrow-left-rollover.png" alt="">
</div>
